/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name unavailabilityweek
 */
angular.module('mercury.modules.time.roster')
.directive('unavailabilityweek', ["reporttime", "$parse", function(reporttime, $parse) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {

      // We stop click propagation on the unavailability div so that on mobile
      // a user can tap on the collapsed unavailability block and the css :active
      // pseudoclass will be applied without the add shift dialog appearing. We
      // then use that state to expand the reason detail for the unavailability
      // via a CSS rule.
      element.on('click', event => {
        event.stopPropagation();
      });

    }
  };
}]);
